import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import UploadProgressBar from '../UploadProgressBar';

export default function UploaderDashboardItem(props) {
    const { path, progress, status } = props;
    return (
        <>
            <Grid item xs={12}>
                <Typography>
                    {path}
                </Typography>
                <UploadProgressBar value={progress} status={status}></UploadProgressBar>
            </Grid>
        </>
    );
}